// Business legal details for marketing email footers.
//
// UK law needs different sender disclosures depending on legal form:
// limited companies must show registered name, company number, place of
// registration and registered office on business emails (Companies Act 2006
// trading disclosures); the self-employed need their name and business
// address. BACKED BY THE API since June 2026 (v2/marketing/business-details,
// per salon) — the send engine resolves {{CompanyDetails}} from the server
// copy with maths identical to companyDetailsLine below. localStorage is
// the cache; call hydrateBusinessDetails() on mount.

import { marketingBackend } from '../marketing-v2/services/marketingBackend';

const storageKey = (salonId) => `beu-business-details-${salonId || 'default'}`;

/** Pull the salon's details from the backend into the cache. */
export const hydrateBusinessDetails = async (salonId) => {
  try {
    const server = await marketingBackend.businessDetailsGet();
    if (server && server.details) {
      try { localStorage.setItem(storageKey(salonId), JSON.stringify(server.details)); } catch (e) { /* ignore */ }
      return server.details;
    }
    return loadBusinessDetails(salonId);
  } catch (e) {
    console.error('business details hydrate failed (cache kept):', e.message);
    return loadBusinessDetails(salonId);
  }
};

export const loadBusinessDetails = (salonId) => {
  try {
    const raw = localStorage.getItem(storageKey(salonId));
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
};

export const saveBusinessDetails = (salonId, details) => {
  try {
    localStorage.setItem(storageKey(salonId), JSON.stringify(details));
  } catch (e) { /* storage full or blocked; the cache simply will not persist */ }
  marketingBackend.businessDetailsSave(details)
    .catch((e) => console.error('business details save failed:', e.message));
};

// The footer line {{CompanyDetails}} resolves to
export const companyDetailsLine = (d) => {
  if (!d) return '';
  if (d.legalForm === 'ltd') {
    const bits = [];
    if (d.registeredName) bits.push(d.registeredName);
    if (d.companyNumber) bits.push(`Registered in ${d.placeOfRegistration || 'England and Wales'}, company no. ${d.companyNumber}`);
    if (d.registeredOffice) bits.push(`Registered office: ${d.registeredOffice}`);
    return bits.join(' · ');
  }
  return d.tradingName ? `Trading as ${d.tradingName}` : '';
};

export const isBusinessDetailsComplete = (d) => {
  if (!d || !d.legalForm) return false;
  if (d.legalForm === 'ltd') return Boolean(d.registeredName && d.companyNumber && d.registeredOffice);
  return true; // self-employed: salon name + address already cover the legal minimum
};
